import $ from "jquery";
import React, { Component } from "react";
import { Fields, formValueSelector, change } from "redux-form";
import { connect } from "react-redux";
import { Row, Column } from "react-foundation";

import Loading from "components/Loading";
import ImageResolver from "containers/ImageResolver.js";
import { addPreviousPreviews } from "./../../../actions";
import InputError from "../../../components/InputError";
import ThemeButton from "../../../components/ThemeButton";
import SeparatingLine from "../../../components/SeparatingLine";
import { getCompositeDoorColours } from "./../../../selectors";
import FormHeader from "../../../components/FormHeader";
import FormWrapper from "../../FormWrapper";
import HandleSelector from '../../../components/HandleSelector';
import utils from '../../../utils';
import { updatePreviousSelection } from '../../../actions';

const SelectHandle = props => {
    let { handles, DoorHandleType, DoorHandleId, selectedColour, addPreviousPreviews, useAltBestMatch, previousSelection } = props;

    if ($.isEmptyObject(handles)) {
        return <Loading />;
    }

    return (
        <div>
            <HandleSelector
                handles={handles}
                HandleType={DoorHandleType}
                HandleId={DoorHandleId}
                selectedColour={selectedColour}
                useAltBestMatch={useAltBestMatch}
                addPreviousPreviews={val => addPreviousPreviews({ extraId: val }, [7])}
                previousSelectionHandleColour={previousSelection.DoorCompositeHandleColour} />

            <InputError metas={DoorHandleType.meta} />
        </div>
    );
};

class HandleForm extends Component {

    constructor() {
        super();
        this.state = {
            loaded: false
        };
    }

    componentDidUpdate() {
        let { handles, selectedColour, hasPreviewImages, selectedHandle, dispatch, selectedType, previousSelection, addPreviousPreviews } = this.props;

        if (!selectedHandle.id && hasPreviewImages && this.state.loaded === false) {
            if (handles.length > 0) {
                // do somthing
                if (window.Foundation.MediaQuery.current === "small") {

                    var handleId = utils.getExtraBestMatch(handles, selectedColour, selectedType.useAltBestMatch);

                    var previousHandleId = utils.findHandleByColour(handles, previousSelection.DoorCompositeHandleColour, previousSelection.DoorCompositeHandleType);

                    handleId = previousHandleId || handleId;

                    var handle = utils.getValueById(handles, handleId);

                    addPreviousPreviews({ extraId: handleId }, [7]);
                    dispatch(change("DoorWizard", "DoorHandleId", handleId));
                    dispatch(change("DoorWizard", "DoorHandleType", handle.description2));
                    this.setState({ loaded: true });
                }
            }
        }
    }

    onSubmit(values) {

        var handle = utils.getValueById(this.props.handles, values.DoorHandleId);

        this.props.updatePreviousSelection({
            DoorCompositeHandleColour: handle.description1,
            DoorCompositeHandleType: handle.description2
        });

        this.props.onSubmit(values);
    }

    render() {
        return (
            <form className="HandleForm composite" onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))}>
                <FormHeader title={"Handles & locks"} subtitle={"We can supply a wide range of finish colours and textures"} />

                <SeparatingLine />

                <FormWrapper>
                    <Row collapseOnSmall uncollapseOnMedium>
                        <Column pushOnLarge={6} large={6} className="preview-container">
                            <ImageResolver
                                query={{ productId: 14 }}
                                filters={{ extraId: this.props.selectedHandle.id }}
                                handles
                            />
                        </Column>
                        <Column pullOnLarge={6} large={6}>
                            <Row>
                                <Column small={12}>
                                    <Fields
                                        names={["DoorHandleType", "DoorHandleId"]}
                                        component={SelectHandle}
                                        handles={this.props.handles}
                                        selectedColour={this.props.selectedColour}
                                        addPreviousPreviews={this.props.addPreviousPreviews}
                                        useAltBestMatch={this.props.selectedType.useAltBestMatch}
                                        previousSelection={this.props.previousSelection}
                                    />
                                </Column>
                            </Row>
                        </Column>
                    </Row>
                </FormWrapper>

                <div className="button-panel">
                    <SeparatingLine />
                    <button className="button back" type="button" onClick={this.props.previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    let valueSelector = formValueSelector("DoorWizard");
    let doorHandleId = valueSelector(state, "DoorHandleId");
    let doorTypeId = valueSelector(state, "DoorTypeId") || 7;
    let exteriorColourId = valueSelector(state, "DoorExteriorColourId");

    let extras = state.Door.Options.extras;

    let handles = extras.filter(e => /handle/i.test(e.extraGroupName));
    handles.sort(utils.sortExtraByRank);

    let exteriorColours = getCompositeDoorColours(state, "external");

    let selectedHandle = {};

    if (doorHandleId) selectedHandle = handles.filter(c => c.id === doorHandleId)[0] || {};
    let selectedColour = exteriorColours.filter(c => c.id === exteriorColourId)[0];


    let selectedType = state.Door.Types.filter(c => c.id === doorTypeId)[0] || {};

    return {
        handles,
        selectedHandle,
        selectedColour,
        selectedType,
        hasPreviewImages: state.PreviewImages.length > 0,
        previousSelection: state.PreviousSelection
    };
};

export default connect(mapStateToProps, { addPreviousPreviews, updatePreviousSelection })(HandleForm);



// WEBPACK FOOTER //
// ./src/containers/DoorForm/composite/HandleForm.js